import $ from 'jquery'
import Analytics from "@MAIN/modules/Analytics"
import API from "@MAIN/app/api"
import Modal from '@MAIN/app/modules/Modal'
import RecombeeClient from "@MAIN/modules/RecombeeClient";

const addToCartHandler = async function(e) {
  e.preventDefault()
  e.stopPropagation()

  if ($(this).attr('disabled') === 'disabled')
    return

  const type = $(this).data('type')
  let $elemProductAddButton = $(this)

  if (type === 'product-list') {
    $elemProductAddButton = $elemProductAddButton.parent()
  }

  $(this)
    .attr('disabled', 'disabled')
    .append( $('#loader-template').html() )

  const product_id = $(this).data('product-id');

  Promise.all([
    API.cart.add(product_id),
    API.cart.get_related_products([product_id])
  ]).then(([cart, related_products]) => {
    Object.assign(window.CART_FULL, cart)

    Modal.setType('cart')
      .then(() => {
        Modal.getComponent().set(product_id, related_products)
      })

    $(this)
      .removeAttr('disabled')
      .children().last().remove()

    if (type !== 'product-list') {
      $elemProductAddButton.addClass('d-none')
    }

    $elemProductAddButton.next().removeClass('d-none')
  })

  Analytics.addToCartButtonClicked({
    id: product_id,
    name: $(this).data('product-name'),
    price: $(this).data('product-price')
  })
}

$(() => {
  $('.js-add-to-cart').click(addToCartHandler)
})

$('.js-order-fast').click(async function(e) {
  e.preventDefault()

  const product_id = $(this).data('product-id');

  await Modal.setType('FastOrder')
  await Modal.getComponent().set(product_id)
})

$('.js-pre-order').click(async function(e) {
  e.preventDefault()

  const product_id = $(this).data('product-id');

  await Modal.setType('OrderPreOrder')
  await Modal.getComponent().set(product_id)
})


const handleAddToCartButtonsFor$Element = function($elem ) {
  $elem.find(`.js-add-to-cart`).click(addToCartHandler)
}

export {
  handleAddToCartButtonsFor$Element
}
